function injectStyle (ssrContext) {
  require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-47b4cb1f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../vue-loader/lib/selector?type=styles&index=0!./ItemList.vue")
}
var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./ItemList.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-47b4cb1f\",\"hasScoped\":true}!../../../vue-loader/lib/selector?type=template&index=0!./ItemList.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-47b4cb1f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/@sdgsystems/vue-common/components/ItemList.vue
// module id = 25
// module chunks = 1